
import { useEffect } from 'react';
import { KpiCardType } from '../types';
import { logStatsData } from '@/components/dashboard/stats/utils/logger';

export const useQaTesting = (
  kpiCards: KpiCardType[], 
  setKpiCards: React.Dispatch<React.SetStateAction<KpiCardType[]>>
) => {
  // Only run in development mode with explicit test flag
  useEffect(() => {
    // Check if we're in test mode (require explicit flag)
    const urlParams = new URLSearchParams(window.location.search);
    const autoTest = urlParams.get('autoTest');
    
    // Only run in development mode with explicit test flag
    if (autoTest !== 'gas') return;
    
    // For testing in development only
    logStatsData(`Gas QA Testing Mode: Active with ${kpiCards.length} KPI cards`);
  }, [kpiCards]);
};
